/*
 * @Author: bz2021
 * @Date: 2025-07-01 20:16:40
 * @Description: 忘记密码页面
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Layout, Button, Input, Space, message } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone, MailOutlined } from '@ant-design/icons';
import request from '../../utils/request';

const { Header, Content } = Layout;

const headerStyle = {
    textAlign: 'center',
    color: '#fff',
    height: 64,
    paddingInline: 48,
    lineHeight: '64px',
    backgroundColor: '#ED4948',
};
const contentStyle = {
    textAlign: 'center',
    padding: '10px',
    minHeight: 380,
    color: '#000',
};

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        verifyCode: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [countdown, setCountdown] = useState(60);
    const [isCounting, setIsCounting] = useState(false);
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const sendVerifyCode = async () => {
        if (!formData.email) {
            messageApi.error('请先输入邮箱');
            return;
        }
        try {
            setIsCounting(true);
            setCountdown(60);
            await request.post(`/send_reset_verify_code?email=${formData.email}`);
            messageApi.success('验证码发送成功');
            const timer = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsCounting(false);
                        return 60;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (error) {
            messageApi.error('验证码发送失败');
            setIsCounting(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // 表单验证
        if (!formData.email) {
            messageApi.error('请输入邮箱');
            setLoading(false);
            return;
        }
        if (!formData.verifyCode) {
            messageApi.error('请输入验证码');
            setLoading(false);
            return;
        }
        if (!formData.newPassword || formData.newPassword.length < 6) {
            messageApi.error('请输入至少6位的新密码');
            setLoading(false);
            return;
        }
        if (formData.newPassword !== formData.confirmPassword) {
            messageApi.error('两次密码输入不一致');
            setLoading(false);
            return;
        }

        try {
            await request.post('/reset_password', {
                email: formData.email,
                verify_code: formData.verifyCode,
                new_password: formData.newPassword
            });
            messageApi.success('密码重置成功，请登录');
            navigate('/login');
        } catch (error) {
            if (error.response) {
                messageApi.error(error.response.data.msg || '密码重置失败');
            } else {
                messageApi.error('网络错误，请稍后重试');
            }
        }
        setLoading(false);
    };

    return (
        <div>
            {contextHolder}
            <Header style={headerStyle}>忘记密码</Header>
            <Content style={contentStyle}>
                <Space direction="vertical">
                    <Input 
                        placeholder="请输入邮箱"
                        prefix={<MailOutlined />}
                        value={formData.email}
                        name="email"
                        onChange={handleChange}
                    />
                    <Space.Compact style={{ width: '100%' }}>
                        <Input 
                            placeholder="请输入验证码"
                            value={formData.verifyCode}
                            name="verifyCode"
                            onChange={handleChange}
                        />
                        <Button 
                            onClick={sendVerifyCode} 
                            disabled={isCounting}
                        >
                            {isCounting ? `${countdown}秒后重新发送` : '发送验证码'}
                        </Button>
                    </Space.Compact>
                    <Input.Password
                        placeholder="请输入新密码（至少6位）"
                        visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
                        value={formData.newPassword}
                        name="newPassword"
                        onChange={handleChange}
                    />
                    <Input.Password
                        placeholder="请确认新密码"
                        visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
                        value={formData.confirmPassword}
                        name="confirmPassword"
                        onChange={handleChange}
                    />
                    <Button 
                        style={{ background: '#ED4948', color: '#fff' }} 
                        variant="solid" block
                        onClick={handleSubmit}
                        loading={loading}
                    >
                        重置密码
                    </Button>
                    <Button 
                        style={{ color: '#ED4948' }}
                        variant="solid" block
                        onClick={() => navigate('/login')}
                    >
                        返回登录
                    </Button>
                </Space>
            </Content>
        </div>
    );
};

export default ForgotPassword;